import(/* webpackMode: "eager" */ "/codebuild/output/src1214854546/src/client/src/app/(public)/loading.tsx");
